function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import { useEffect } from 'react';
import { useRefCallback, useSingleton } from '@bydesign-ui/hooks';
import { deepEqual } from '@bydesign-ui/utils';
import { AutoComplete } from '../../../models/autocomplete';
export function useMultipleAutoComplete(options) {
  var onSearch = options.onSearch,
      onChange = options.onChange,
      value = options.value,
      dataSource = options.dataSource,
      extra = _objectWithoutProperties(options, ["onSearch", "onChange", "value", "dataSource"]);

  var root = useSingleton(function () {
    return new AutoComplete();
  });
  var handleSearch = useRefCallback(function (v) {
    onSearch && onSearch(v);
  });
  var handleChange = useRefCallback(function (value) {
    onChange && onChange(value);
  });

  var convertSelectedValue = function convertSelectedValue(selectedValue) {
    return selectedValue.map(function (value) {
      var filterLabel = dataSource.filter(function (item) {
        return deepEqual(item.value, value);
      });
      var label = filterLabel.length > 0 ? filterLabel[0].label : '';
      return {
        label: label,
        value: value
      };
    });
  };

  root.updateOptions(_objectSpread({
    dataSource: dataSource,
    multiple: true,
    selectedValue: value && convertSelectedValue(value)
  }, extra));
  useEffect(function () {
    root.addListener('on-select', handleChange);
    root.addListener('on-search', handleSearch);
    return function () {
      root.removeListener('on-select', handleChange);
      root.removeListener('on-search', handleSearch);
    };
  }, []);
  return root;
}